export const isNotNullOrUndefined = (value: any): boolean => {
  return value !== null && value !== undefined;
};
